import { render, staticRenderFns } from "./ResetDataButton.vue?vue&type=template&id=d9029168&scoped=true&"
import script from "./ResetDataButton.vue?vue&type=script&lang=js&"
export * from "./ResetDataButton.vue?vue&type=script&lang=js&"
import style0 from "./ResetDataButton.vue?vue&type=style&index=0&id=d9029168&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9029168",
  null
  
)

export default component.exports